module.exports = __webpack_public_path__ + "static/media/9.c2df2d7e.jpg";